/**Модель очереди */
export class QueueModel {
  /**Идентификатор */
  Id!: string;
  /**Имя */
  Name!: string;
  /**Количество задач */
  Count: number = 0;
  /**Id рабочей области */
  NamespaceId!: string;
  /** Флаг проверяющий настроенная ли очередь */
  IsQueueConfigured?: boolean = false;

  constructor(obj?: Partial<QueueModel>) {
    if (obj) Object.assign(this, obj);
  }
}
